import { confirmActions } from '../actions'
const { ADD_FUNCTION, CLEAR_FUNCTION } = confirmActions

const initialState = {
  confirmMessage: '',
  confirmFunction: null
}

const confirm = (state = initialState, action = {}) => {
  switch (action.type) {
    case ADD_FUNCTION:
      return {
        ...state,
        confirmMessage: action.confirmMessage || '',
        confirmFunction: action.confirmFunction
      }
    case CLEAR_FUNCTION:
      return {
        ...state,
        confirmFunction: initialState.confirmFunction
      }
    default:
      return state
  }
}

export default confirm



// WEBPACK FOOTER //
// ./src/reducers/confirm.js